// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import http from "../utils/http";
import "../utils/dateFormat";
import "@/assets/scss/public.scss";
import xlsx from "../utils/xlsx";

Vue.use(ElementUI);

// 挂载全局
Vue.prototype.$http = http
Vue.prototype.$xlsx = xlsx;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js